import { useIntegratedActionBroadcaster } from '../action-broadcaster/use-integrated-action-broadcaster';
import { useApplicationType } from '../common/hooks/use-application-type';
import { useProQaMetadataStore } from './provider/pro-qa-metadata-provider';

export function useProQaMetadataListener() {
    const { isWeb } = useApplicationType();
    const proQaMetadataStore = useProQaMetadataStore();

    useIntegratedActionBroadcaster({
        windowType: 'EVENT_V2',
        ignoreActiveWorkspaceWindowType: isWeb,
        handler(action) {
            if (action.type === 'PRO_QA_EVENT_METADATA_RECEIVED') {
                proQaMetadataStore.setProQaMetadata(action.payload);
                return true;
            }
            return false;
        },
    });

    return null;
}
